(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7988],{

/***/ 47988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ JobAlertCard; },
  "F2": function() { return /* reexport */ JobAlertDialogText; },
  "gs": function() { return /* reexport */ JobAlertPreferencesDialog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Dialog/index.tsx + 1 modules
var Dialog = __webpack_require__(22139);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./modules/Context/FeedbackContextProvider.tsx + 10 modules
var FeedbackContextProvider = __webpack_require__(34272);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./modules/JobAlerts/components/JobAlertChip/JobAlertChip.module.scss
var JobAlertChip_module = __webpack_require__(67882);
var JobAlertChip_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertChip_module);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertChip/JobAlertChip.tsx




var JobAlertChip = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (JobAlertChip_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: label,
            color: "primary",
            variant: "outlined",
            className: (JobAlertChip_module_default()).chip
        })
    });
};
/* harmony default export */ var JobAlertChip_JobAlertChip = (JobAlertChip);

;// CONCATENATED MODULE: ./types/alerts.ts
var JobAlertFrequency;
(function(JobAlertFrequency) {
    JobAlertFrequency["OnceADay"] = "Once a day";
    JobAlertFrequency["Immediately"] = "As soon as a job matches";
})(JobAlertFrequency || (JobAlertFrequency = {}));

// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/dist/index.esm.js
var index_esm = __webpack_require__(96235);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var dist_index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(52541);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./modules/JobAlerts/components/JobAlertPreferencesDialog/JobAlertPreferencesDialog.module.scss
var JobAlertPreferencesDialog_module = __webpack_require__(43537);
var JobAlertPreferencesDialog_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertPreferencesDialog_module);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertPreferencesDialog/JobAlertPreferencesDialog.tsx






















var JOB_ALERT_REACH_MAXIMUM_NUMBER = 10100;
var JOB_ALERT_LIVE_REACH_MAXIMUM_NUMBER = 10101;
var getDialogTitle = function(hasReachedTotalMaximum, hasReachedLiveMaximum, isEditing) {
    if (hasReachedTotalMaximum) {
        return "Whoa! You've reached the maximum number of job alerts";
    }
    if (hasReachedLiveMaximum) {
        return "Whoa! You've reached the maximum number of live job alerts";
    }
    if (isEditing) {
        return "Edit job alert preferences";
    } else {
        return "Set alert preferences";
    }
};
var SigninSchema = yup_index_esm.object().shape({
    name: yup_index_esm.string().trim().required(),
    frequency: yup_index_esm.string().trim().required()
});
var JobAlertPreferencesDialog = function(_param) {
    var alert = _param.alert, query = _param.query, show = _param.show, hide = _param.hide, successCallBack = _param.successCallBack, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "alert",
        "query",
        "show",
        "hide",
        "successCallBack"
    ]);
    var ref, ref1;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isEditing = !!alert;
    var submitButtonText = isEditing ? "Save preferences" : "Save job alert";
    var footerText = isEditing ? "" : "All saved alerts can be managed from the Job alerts menu";
    var showAsSoonAs = !!query.grade && (!!query.speciality || !!query.rootSpeciality);
    var setFeedBack = (0,FeedbackContextProvider/* useFeedBackOutlet */.UR)();
    var ref2 = (0,react.useState)(false), processing = ref2[0], setProcessing = ref2[1];
    var ref3 = (0,react.useState)(false), hasReachedTotalMaximum = ref3[0], setHasReachedTotalMaximum = ref3[1];
    var ref4 = (0,react.useState)(false), hasReachedLiveMaximum = ref4[0], setHasReachedLiveMaximum = ref4[1];
    var ref5 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,index_esm/* yupResolver */.Xp)(SigninSchema),
        reValidateMode: "onChange",
        mode: "onChange"
    }), register = ref5.register, handleSubmit = ref5.handleSubmit, errors = ref5.errors;
    var router = (0,next_router.useRouter)();
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var newQuery, eventName, saveAlertFunction, saveAlertQueryData, saveAlertFunctionData, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newQuery = (0,jobListingHelper/* purgeQuery */.S4)(query);
                        setProcessing(true);
                        eventName = isEditing ? "Alert Updated" : "Alert Created";
                        track(eventName, (0,_object_spread/* default */.Z)({}, newQuery, data));
                        saveAlertFunction = function(data) {
                            return isEditing ? (0,useRequest/* updateAlerts */.uu)(alert.id, data) : (0,useRequest/* saveAlerts */.Hr)(data);
                        };
                        saveAlertQueryData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newQuery), {
                            speciality: newQuery.rootSpeciality,
                            rootSpeciality: undefined
                        });
                        saveAlertFunctionData = (0,_object_spread/* default */.Z)({}, saveAlertQueryData, data);
                        return [
                            4,
                            saveAlertFunction(saveAlertFunctionData)
                        ];
                    case 1:
                        result = _state.sent();
                        if ("error" in result) {
                            if ("errorCode" in result.error) {
                                if (result.error.errorCode === JOB_ALERT_REACH_MAXIMUM_NUMBER) {
                                    setHasReachedTotalMaximum(true);
                                } else if (result.error.errorCode === JOB_ALERT_LIVE_REACH_MAXIMUM_NUMBER) {
                                    setHasReachedLiveMaximum(true);
                                } else {
                                    setFeedBack(result);
                                }
                            } else {
                                setFeedBack(result);
                            }
                            return [
                                2,
                                setProcessing(false)
                            ];
                        }
                        setFeedBack(result);
                        setProcessing(false);
                        successCallBack === null || successCallBack === void 0 ? void 0 : successCallBack();
                        hide();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeDialog = function() {
        setHasReachedTotalMaximum(false);
        setHasReachedLiveMaximum(false);
        hide();
    };
    var goToJobAlertPage = function() {
        router.push(path/* PATH.JOBS_ALERTS */.m.JOBS_ALERTS);
        closeDialog();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: getDialogTitle(hasReachedTotalMaximum, hasReachedLiveMaximum, isEditing),
            show: show,
            onClose: closeDialog
        }, rest), {
            children: hasReachedTotalMaximum || hasReachedLiveMaximum ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertDialogText, {
                closeDialog: closeDialog,
                goToJobAlertPage: goToJobAlertPage
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobAlertPreferencesDialog_module_default()).dialogForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (JobAlertPreferencesDialog_module_default()).groupLabel,
                                children: "Search filters:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (JobAlertPreferencesDialog_module_default()).tagRow,
                                "data-testid": "alert-dialog-search-filters",
                                children: (0,jobListingHelper/* getJobAlertQueryDisplayValues */.l7)(query).map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertChip_JobAlertChip, {
                                        label: item
                                    }, item);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (JobAlertPreferencesDialog_module_default()).dialogForm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            name: "name",
                            fullWidth: true,
                            defaultValue: alert === null || alert === void 0 ? void 0 : alert.name,
                            inputRef: register,
                            label: "Name of job alert",
                            error: !!((ref = errors.name) === null || ref === void 0 ? void 0 : ref.message),
                            helperText: (ref1 = errors.name) === null || ref1 === void 0 ? void 0 : ref1.message,
                            inputProps: {
                                "data-testid": "alert-dialog-name-field"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (JobAlertPreferencesDialog_module_default()).dialogForm,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (JobAlertPreferencesDialog_module_default()).groupLabel,
                                children: "Notification frequency:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                                name: "frequency",
                                defaultValue: JobAlertFrequency.OnceADay,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        inputRef: register,
                                        value: JobAlertFrequency.OnceADay,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: "Alert me once a day",
                                        "data-testid": "alert-dialog-once-radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        inputRef: register,
                                        disabled: !showAsSoonAs,
                                        value: JobAlertFrequency.Immediately,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: "Alert as soon as a job matches my search (requires at least a grade and speciality)",
                                        "data-testid": "alert-dialog-immediately-radio"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        disabled: processing,
                        fullWidth: true,
                        variant: "contained",
                        size: "large",
                        color: "secondary",
                        "data-testid": "alert-dialog-submit",
                        children: submitButtonText
                    }),
                    footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (JobAlertPreferencesDialog_module_default()).footer,
                        "data-testid": "alert-dialog-footer",
                        children: footerText
                    })
                ]
            })
        }))
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./modules/JobAlerts/components/JobAlertCard/JobAlertCard.module.scss
var JobAlertCard_module = __webpack_require__(23864);
var JobAlertCard_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertCard_module);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertCard/imgs/edit.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.723 13.977c-.079.078-.079.156-.079.234v4.414H1.895V4.875h9.415c.078 0 .156 0 .234-.078l1.25-1.25c.195-.195.039-.547-.234-.547H1.895C.84 3 .02 3.86.02 4.875v13.75c0 1.055.82 1.875 1.875 1.875h13.75c1.015 0 1.875-.82 1.875-1.875v-5.664c0-.274-.352-.43-.547-.234l-1.25 1.25Zm6.093-7.852a2.287 2.287 0 0 0 0-3.242l-1.68-1.68a2.287 2.287 0 0 0-3.241 0L6.66 11.438l-.39 3.554a1.586 1.586 0 0 0 1.757 1.758l3.555-.39L21.816 6.124Zm-3.828 1.172-7.265 7.266-2.578.312.312-2.578 7.266-7.266 2.265 2.266Zm2.5-3.086c.196.156.196.39.04.586l-1.212 1.21-2.265-2.304 1.172-1.172a.366.366 0 0 1 .586 0l1.68 1.68Z"
  })));
};
/* harmony default export */ var edit = (SvgEdit);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertCard/imgs/remove.svg
var remove_path, _path2;
function remove_extends() { return remove_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, remove_extends.apply(null, arguments); }

var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/react.createElement("svg", remove_extends({
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), remove_path || (remove_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.625 5.25h1v6h-1zM7.625 5.25h1v6h-1zM5.625 5.25h1v6h-1z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.813 2.188h-2.27L8.613.655C8.395.301 7.903 0 7.493 0H4.73c-.41 0-.902.3-1.12.656l-.93 1.531H.437A.45.45 0 0 0 0 2.626v.438c0 .246.191.437.438.437h.437l.574 9.27c.028.683.63 1.23 1.313 1.23H9.46c.684 0 1.285-.547 1.312-1.23l.602-9.27h.438a.45.45 0 0 0 .437-.438v-.437a.47.47 0 0 0-.438-.438ZM4.73 1.312h2.762l.52.875H4.21l.52-.874Zm4.73 11.376H2.763L2.187 3.5h7.848l-.574 9.188Z"
  })));
};
/* harmony default export */ var remove = (SvgRemove);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertCard/JobAlertCard.tsx
















var JobAlertCard = function(param) {
    var data = param.data, openDialog = param.openDialog, onDelete = param.onDelete;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var updatedAt = data.updatedAt, frequency = data.frequency, id = data.id, name = data.name, query = data.query, isDeleted = data.isDeleted;
    var handleEdit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                openDialog(data);
                return [
                    2
                ];
            });
        });
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTitleClick = function() {
        return track("Saved job alert title click", {});
    };
    var jobSearchLink = (0,jobListingHelper/* generateJobListingsUrlObject */.hX)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        jobAlert: "Manage"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((JobAlertCard_module_default()).container, isDeleted ? (JobAlertCard_module_default()).hideCard : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        md: 10,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: jobSearchLink,
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (JobAlertCard_module_default()).titleLink,
                                    "data-testid": "job-alert-search-link",
                                    onClick: handleTitleClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h5",
                                        component: "h2",
                                        "data-testid": "job-alert-name",
                                        className: (JobAlertCard_module_default()).title,
                                        children: name
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                "data-testid": "job-alert-container",
                                className: (JobAlertCard_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (JobAlertCard_module_default()).tagRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Search filters:"
                                            }),
                                            (0,jobListingHelper/* getJobAlertQueryDisplayValues */.l7)(query).map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertChip_JobAlertChip, {
                                                    label: item
                                                }, item);
                                            })
                                        ]
                                    }),
                                    frequency !== "none" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (JobAlertCard_module_default()).tagRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Frequency:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertChip_JobAlertChip, {
                                                label: frequency
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 2,
                        xs: 12,
                        className: (JobAlertCard_module_default()).alignRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (JobAlertCard_module_default()).button,
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(edit, {
                                width: 23,
                                height: 21
                            }),
                            onClick: handleEdit,
                            "data-testid": "job-alert-edit-button",
                            children: "Edit alert"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 9,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: (JobAlertCard_module_default()).button,
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(remove, {
                                width: 13,
                                height: 14
                            }),
                            "data-testid": "job-alert-delete-button",
                            onClick: function() {
                                onDelete(id);
                            },
                            children: "Remove"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        md: 3,
                        xs: 6,
                        className: classnames_default()((JobAlertCard_module_default()).date, (JobAlertCard_module_default()).alignRight),
                        children: [
                            "Saved ",
                            dayjs_min_default()(updatedAt).format("DD MMM YYYY")
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/JobAlerts/components/JobAlertDialogText/JobAlertDialogText.module.scss
var JobAlertDialogText_module = __webpack_require__(20811);
var JobAlertDialogText_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertDialogText_module);
;// CONCATENATED MODULE: ./modules/JobAlerts/components/JobAlertDialogText/JobAlertDialogText.tsx




var JobAlertDialogText = function(param) {
    var goToJobAlertPage = param.goToJobAlertPage, closeDialog = param.closeDialog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "alert-dialog-max-limit-reached",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (JobAlertDialogText_module_default()).dialogDetail,
                children: "Please delete one of your existing alerts to save a new one."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (JobAlertDialogText_module_default()).dialogButton,
                fullWidth: true,
                variant: "contained",
                size: "large",
                color: "secondary",
                onClick: goToJobAlertPage,
                children: "Manage job alerts"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (JobAlertDialogText_module_default()).dialogButton,
                fullWidth: true,
                size: "large",
                color: "secondary",
                onClick: closeDialog,
                children: "Cancel"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/JobAlerts/index.tsx





/***/ }),

/***/ 23864:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertCard_container__OXerr","grade":"JobAlertCard_grade__3JbRp","title":"JobAlertCard_title__D2ui7","titleLink":"JobAlertCard_titleLink__2KZX1","content":"JobAlertCard_content__x7xNI","tagRow":"JobAlertCard_tagRow__51BjH","button":"JobAlertCard_button__04YQC","date":"JobAlertCard_date__TzJYE","alignRight":"JobAlertCard_alignRight__TGtIp","hideCard":"JobAlertCard_hideCard__51r6A","hideCardAction":"JobAlertCard_hideCardAction__1FdlT","confirmButton":"JobAlertCard_confirmButton___vKXg"};

/***/ }),

/***/ 67882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertChip_container__4AWY5","chip":"JobAlertChip_chip__jbLeI"};

/***/ }),

/***/ 20811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogDetail":"JobAlertDialogText_dialogDetail__TBMkS","dialogButton":"JobAlertDialogText_dialogButton__km2B2"};

/***/ }),

/***/ 43537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogForm":"JobAlertPreferencesDialog_dialogForm__yu8ds","groupLabel":"JobAlertPreferencesDialog_groupLabel__bmcMa","tagRow":"JobAlertPreferencesDialog_tagRow__310hT","footer":"JobAlertPreferencesDialog_footer__aRpT4"};

/***/ })

}]);